import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

export const formatDate = (dateString: string) => {
  return dayjs(dateString)
    .tz("America/Los_Angeles")
    .format("MMMM D, YYYY h:mm a");
};

export const shortFormatDate = (dateString: string) => {
  return dayjs(dateString).tz("America/Los_Angeles").format("MM/DD/YYYY");
};

export const shortFormatDateTimezoneFree = (dateString: string) => {
  return dayjs(dateString).format("MM/DD/YYYY");
};

export const formatShortMonthDate = (dateString: string | Date) => {
  const date = dayjs(dateString);
  return date.format("D MMM, YYYY");
};

export const formatProjectDate = (dateString: string) => {
  return dayjs(dateString).tz("America/Los_Angeles").format("D MMM, YYYY");
};

// Date-only formatter for CSV exports. Renders the Pacific (America/Los_Angeles)
// calendar date so a late-in-the-day UTC timestamp doesn't roll to the next day
// for exporters in timezones ahead of UTC (SDCP-1296).
export const formatExportDate = (dateString: string) => {
  return dayjs(dateString).tz("America/Los_Angeles").format("MMMM D, YYYY");
};

// Operationalized Date is a reported program date, so every viewer must read the same calendar
// day for it. It is stored as an instant, and rendering that instant in the browser's own
// timezone shifted the displayed day for anyone outside Pacific — an admin in Pacific entering
// May 11 stores 2026-05-12T03:00Z, which reads as May 12 anywhere east of UTC. Pinning the
// render to the program's timezone keeps the day stable wherever it is viewed, the same way
// CSV exports were pinned in SDCP-1296.
export const formatOperationalizedDate = (dateString: string) => {
  return dayjs(dateString).tz("America/Los_Angeles").format("MMMM D, YYYY");
};

export const formatDateLocal = (dateString: string) => {
  return dayjs(dateString).format("MMMM D, YYYY h:mm a");
};

export const getMonthName = (monthNumber: number): string => {
  return new Intl.DateTimeFormat("en-US", { month: "long" }).format(
    new Date(2000, monthNumber - 1)
  );
};
